import type { Specialty } from '@/types/app'
import type {
  SpecialtiesResponse,
  SpecialtyResponse,
} from '@/apis/repositories/models/derek'
import { isMatchingFilterResponse } from './matchingFilter'

export const parseSpecialtiesResponseToSpecialties = (
  specialtiesResponse: SpecialtiesResponse
): ReadonlyArray<Specialty> =>
  specialtiesResponse.filter(isSpecialtyResponse).map(item => {
    const { ...specialty } = item
    return specialty
  })

// TODO: specialtyから「富裕層」「女性のみ」が取り除かれたら、この処理は削除する
const isSpecialtyResponse = (
  item: ValueOf<SpecialtiesResponse>
): item is SpecialtyResponse => !isMatchingFilterResponse(item)
